
import { computed, defineComponent, reactive, ref } from 'vue'
import StyledUploader from '@/components/StyledUploader.vue'
import { RespUploadData } from '@/store/respTypes'
import { useStore } from 'vuex'
import { GlobalDataProps } from '@/store'
import { UserDataProps } from '@/store/user'
import { FormInstance, message } from 'ant-design-vue'

const activeKey = ref('information')

interface FormState {
  nickName: string
  picture: string
  gender: 0 | 1 // 0:女 1:男
}
export default defineComponent({
  components: {
    StyledUploader
  },
  setup() {
    const store = useStore<GlobalDataProps>()
    const user = computed(() => store.state.user.data as UserDataProps)

    const formRef = ref<FormInstance>()
    const formState = reactive<FormState>({
      nickName: user.value.nickName || '',
      picture: user.value.picture || '',
      gender: user.value.gender || 0
    })

    const updateAvatar = (rawData: { resp: RespUploadData; file: File }) => {
      const url = rawData.resp.data.urls[0]
      formState.picture = url ?? ''
    }
    const onFinish = async () => {
      try {
        await formRef.value?.validate()

        await store.dispatch('updateUser', {
          urlParams: { id: user.value._id },
          data: { ...formState }
        })
        message.success('修改成功')
      } catch (error) {
        message.error('校验失败')
      }
    }

    return {
      activeKey,
      formRef,
      formState,
      updateAvatar,
      onFinish
    }
  }
})
